import { typographyToCss } from 'shared/lib/mui';
import styled, { css } from 'styled-components';

export const Container = styled.button`
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  align-items: center;
  width: 100%;
  min-height: 3.2rem;

  padding: ${({ theme }) => `${theme.spacing(1)} ${theme.spacing(1.5)}`};
  margin: 0;

  border: none;
  background: transparent;
  text-align: left;

  ${({ as }) =>
    !as &&
    css`
      cursor: pointer;
    `};
`;

export const LabelContainer = styled.span<{
  $hasEntry?: boolean;
  $isToday?: boolean;
  $overdue?: boolean;
}>`
  ${({ theme, $isToday }) =>
    typographyToCss(
      $isToday ? theme.typography.subtitle2 : theme.typography.body2,
    )};
  flex: 1 0 auto;
  min-width: 0;

  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  color: ${({ theme, $hasEntry, $overdue }) =>
    $overdue
      ? theme.palette.error.main
      : $hasEntry
        ? theme.palette.text.primary
        : theme.palette.text.secondary};
`;

export const LabelText = styled.span`
  min-width: 0;
`;

export const InfoIconContainer = styled.span`
  display: flex;
  flex-shrink: 0;
  color: ${({ theme }) => theme.palette.grey[600]};
  font-size: 1.6rem;
`;

export const StartIconContainer = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;

  height: 2rem;
  width: 2rem;

  font-size: 1.6rem;
  color: ${({ theme }) => theme.palette.grey[600]};
  line-height: 62.5%;
`;

export const EndContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  overflow: hidden;
  min-width: 0;
  flex-shrink: 10;
`;

export const TimeButton = styled.button`
  ${({ theme }) => typographyToCss(theme.typography.overline)};

  padding: ${({ theme }) => `${theme.spacing(0.5)}`};
  margin: 0;
  cursor: pointer;
  background: transparent;
  border: none;

  color: ${({ theme }) => theme.palette.text.secondary};

  &:hover {
    color: ${({ theme }) => theme.palette.text.primary};
  }

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  max-width: 12rem;
`;

export const DateLabel = styled.span`
  ${({ theme }) => typographyToCss(theme.typography.body2)};
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const LabelWrapper = styled.span`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
`;
